import React from "react";
import { Text, TextInput, PasswordInput } from "@mantine/core";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { MantineProvider } from "@mantine/core";

interface TextInputRefProps {
  name: string;
  label: string;
  errors: FieldErrors<any>;
  control: Control<any>;
  required?: boolean;
  secure?: boolean;
  disabled?: boolean;
  placeholder?: string;
  maxLength: number | null;
  minLength: number | null;
}

const TextInputRef: React.FC<TextInputRefProps> = ({
  name,
  label,
  errors,
  control,
  required = true,
  secure = false,
  disabled = false,
  placeholder = "",
  maxLength = null,
  minLength = null,
}) => {
  return (
    <MantineProvider>
      {secure ? (
        <Controller
          name={name}
          control={control}
          rules={{ required }}
          render={({ field }) => (
            <PasswordInput
              label={label}
              disabled={disabled}
              placeholder={placeholder}
              {...field}
            />
          )}
        />
      ) : (
        <Controller
          name={name}
          control={control}
          rules={{
            required: required,
            maxLength: maxLength,
            minLength: minLength,
          }}
          render={({ field }) => (
            <TextInput
              label={label}
              disabled={disabled}
              placeholder={placeholder}
              {...field}
            />
          )}
        />
      )}
      {errors?.[name]?.type === "required" && (
        <Text size="sm" style={{ color: "red" }}>
          This field is required
        </Text>
      )}
      {errors?.[name]?.type === "maxLength" && (
        <Text size="sm" style={{ color: "red" }}>
          Max length of {maxLength} exceeded
        </Text>
      )}
      {errors?.[name]?.type === "minLength" && (
        <Text size="sm" style={{ color: "red" }}>
          Min length is {minLength}
        </Text>
      )}
      {errors?.[name] && (
        <Text size="sm" style={{ color: "red" }}>
          {errors?.[name]?.message.toString()}
        </Text>
      )}
    </MantineProvider>
  );
};

export default TextInputRef;
